const referralDictENOld = {
  "Referrals": "Referrals",
  "S.No": "S.No",
  "Name": "Name",
  "Email": "Email",
  "Phone Number": "Phone Number",
  "Referral Status": "Referral Status",
  "Referral Method": "Referral Method",
  "Created At": "Created At",
  "Updated At": "Updated At",
  "Referral": "Referral",
  "Refer with link": "Refer with link",
  "Referral Info": "You can earn points by referring your friends to DX Panel by sharing the given link to facebook, twitter and other social media. Your unique referral link url is: /#/referrals/view/d8010ed8-fc05-4ea8-a505-7cf7692d21c8.",
  "Upload From a CSV list": "Upload From a CSV list",
  "CSV Info": "You can refer multiple friends from a csv file which contains your friends' information in order name, email, mobile. Click here to refer a friend to download sample file.",
  "Choose File": "Choose File",
  "No File Chosen": "No File Chosen",
  "Import": "Import",
  "Refer a friend": "Refer a friend",
  "Name*": "Name*",
  "Email*": "Email*",
  "Mobile": "Mobile",
  "Enter Here": "Enter Here",
  "Refer": "Refer",
  "Manual": "Manual",
  "Invited": "Invited",
  "Filter": "Filter",
  "Creation Date": "Creation Date",
  "Referral Email": "Referral Email",
  "User Email": "User Email",
  "Phone Number Confirmed": "Phone Number Confirmed",
  "Signup Ip": "Signup Ip",
  "Choose": "--Choose--",
  "Accepted": "Accepted",
  "File": "File",
  "Direct Link": "Direct Link",
  "Pending": "Pending",
  "Confirmed": "Confirmed",
  "Others": "Others",
  "Select phone number confirmed status": "--Select phone number confirmed status--",
  "IP": "IP...",
  "Filter Referrals": "Filter Referrals",
  "Export": "Export",
  "Clear Filter": "Clear Filter",
  "Approve Referrals": "Approve Referrals",
  "Rewards Details": "Rewards Details",
};

const referralDictEN = { 'Rewards Details': 'Rewards Details', 'Approve Referrals': 'Approve Referrals', 'Clear Filter': 'Clear Filter', 'Export': 'Export', 'Filter Referrals': 'Filter Referrals', 'IP': 'IP...', 'Select phone number confirmed status': '--Select phone number confirmed status--', 'Others': 'Others', 'Confirmed': 'Confirmed', 'Pending': 'Pending', 'Direct Link': 'Direct Link', 'File': 'File', 'Accepted': 'Accepted', 'Choose': '--Choose--', 'Signup Ip': 'Signup Ip', 'Phone Number Confirmed': 'Phone Number Confirmed', 'User Email': 'User Email', 'Referral Email': 'Referral Email', 'Creation Date': 'Creation Date', 'Filter': 'Filter', 'Invited': 'Invited', 'Manual': 'Manual', 'Refer': 'Refer', 'Enter Here': 'Enter Here', 'Mobile': 'Mobile', 'Email*': 'Email*', 'Name*': 'Name*', 'Refer a friend': 'Refer a friend', 'Import': 'Import', 'No File Chosen': 'No File Chosen', 'Choose File': 'Choose File', 'CSV Info': "You can refer multiple friends from a csv file which contains your friends' information in order name, email, mobile. Click here to refer a friend to download sample file.", 'Upload From a CSV list': 'Upload From a CSV list', 'Referral Info': 'You can earn points by referring your friends to DX Panel by sharing the given link to facebook, twitter and other social media. Your unique referral link url is: /#/referrals/view/d8010ed8-fc05-4ea8-a505-7cf7692d21c8.', 'Refer with link': 'Refer with link', 'Referral': 'Referral', 'Updated At': 'Updated At', 'Created At': 'Created At', 'Referral Method': 'Referral Method', 'Referral Status': 'Referral Status', 'Phone Number': 'Phone Number', 'Email': 'Email', 'Name': 'Name', 'S.No': 'S.No', 'Referrals': 'Referrals' }

const referralDictHIOld = {
  "Referrals": "रेफरल",
  "S.No": "क्र.सं.",
  "Name": "नाम",
  "Email": "ईमेल",
  "Phone Number": "फ़ोन नंबर",
  "Referral Status": "रेफरल स्थिति",
  "Referral Method": "रेफरल पद्धति",
  "Created At": "पर बनाया गया",
  "Updated At": "पर अद्यतन किया गया",
  "Referral": "रेफ़रल",
  "Refer with link": "लिंक के साथ देखें",
  "Referral Info": "आप फेसबुक, ट्विटर और अन्य सोशल मीडिया के दिए गए लिंक को साझा करके अपने दोस्तों को DX Panel में रेफर करके पॉइंट अर्जित कर सकते हैं। आपका अद्वितीय रेफरल लिंक URL है: /#/referrals/view/d8010ed8-fc05-4ea8-a505-7cf7692d21c8।",
  "Upload From a CSV list": "CSV सूची से अपलोड करें",
  "CSV Info": "आप एक .CSV फ़ाइल से कई दोस्तों को रेफर कर सकते हैं जिसमें आपके दोस्तों की जानकारी क्रम, ईमेल, मोबाइल में होती है। नमूना फ़ाइल डाउनलोड करने के लिए एक मित्र को रेफर करने के लिए यहां क्लिक करें।",
  "Choose File": "फ़ाइल चुनें",
  "No File Chosen": "कोई फ़ाइल नहीं चुनी गई",
  "Import": "आयात",
  "Refer a friend": "एक मित्र को रेफर करें",
  "Name*": "नाम*",
  "Email*": "ईमेल*",
  "Mobile": "मोबाइल",
  "Enter Here": "यहाँ से प्रवेश करें",
  "Refer": "रेफर देना",
  "Manual": "नियमावली",
  "Invited": "आमंत्रित",
  "Filter": "फ़िल्टर",
  "Creation Date": "निर्माण तिथि",
  "Referral Email": "रेफरल ईमेल",
  "User Email": "उपयोगकर्ता ईमेल",
  "Phone Number Confirmed": "फोन नंबर की पुष्टि",
  "Signup Ip": "साइनअप आईपी",
  "Choose": "--चुनें--",
  "Accepted": "स्वीकार किया गया",
  "File": "फाइल",
  "Direct Link": "सीधा लिंक",
  "Pending": "लंबित",
  "Confirmed": "पुष्टि की गई",
  "Others": "अन्य",
  "Select phone number confirmed status": "--फोन नंबर की पुष्टि स्थिति चुनें--",
  "IP": "आईपी...",
  "Filter Referrals": "रेफरल फ़िल्टर करें",
  "Export": "निर्यात करें",
  "Clear Filter": "फ़िल्टर साफ़ करें",
  "Approve Referrals": "रेफरल स्वीकृत करें",
  "Rewards Details": "पुरस्कार विवरण",
}

const referralDictHI = { 'Rewards Details': 'पुरस्कार विवरण', 'Approve Referrals': 'रेफरल स्वीकृत करें', 'Clear Filter': 'फ़िल्टर साफ़ करें', 'Export': 'निर्यात करें', 'Filter Referrals': 'रेफरल फ़िल्टर करें', 'IP': 'आईपी...', 'Select phone number confirmed status': '--फोन नंबर की पुष्टि स्थिति चुनें--', 'Others': 'अन्य', 'Confirmed': 'पुष्टि की गई', 'Pending': 'लंबित', 'Direct Link': 'सीधा लिंक', 'File': 'फाइल', 'Accepted': 'स्वीकार किया गया', 'Choose': '--चुनें--', 'Signup Ip': 'साइनअप आईपी', 'Phone Number Confirmed': 'फोन नंबर की पुष्टि', 'User Email': 'उपयोगकर्ता ईमेल', 'Referral Email': 'रेफरल ईमेल', 'Creation Date': 'निर्माण तिथि', 'Filter': 'फ़िल्टर', 'Invited': 'आमंत्रित', 'Manual': 'मैनुअल', 'Refer': 'रेफर देना', 'Enter Here': 'यहाँ से प्रवेश करें', 'Mobile': 'मोबाइल', 'Email*': 'ईमेल*', 'Name*': 'नाम*', 'Refer a friend': 'एक मित्र को रेफर करें', 'Import': 'आयात', 'No File Chosen': 'कोई फ़ाइल नहीं चुनी गई', 'Choose File': 'फ़ाइल चुनें', 'CSV Info': 'आप एक .CSV फ़ाइल से कई दोस्तों को रेफर कर सकते हैं जिसमें आपके दोस्तों की जानकारी क्रम, ईमेल, मोबाइल में होती है। नमूना फ़ाइल डाउनलोड करने के लिए एक मित्र को रेफर करने के लिए यहां क्लिक करें।', 'Upload From a CSV list': 'CSV सूची से अपलोड करें', 'Referral Info': 'आप फेसबुक, ट्विटर और अन्य सोशल मीडिया के दिए गए लिंक को साझा करके अपने दोस्तों को DX Panel में रेफर करके पॉइंट अर्जित कर सकते हैं। आपका अद्वितीय रेफरल लिंक URL है: /#/referrals/view/d8010ed8-fc05-4ea8-a505-7cf7692d21c8।', 'Refer with link': 'लिंक के साथ देखें', 'Referral': 'रेफ़रल', 'Updated At': 'अद्यतन तिथि', 'Created At': 'निर्माण तिथि', 'Referral Method': 'रेफरल विधि', 'Referral Status': 'रेफरल स्थिति', 'Phone Number': 'फ़ोन नंबर', 'Email': 'ईमेल', 'Name': 'नाम', 'S.No': 'क्र.सं.', 'Referrals': 'रेफरल' }

const referralDictJP = { 'Rewards Details': '報酬詳細', 'Approve Referrals': '紹介を承認', 'Clear Filter': 'フィルターをクリア', 'Export': 'エクスポート', 'Filter Referrals': '紹介をフィルター', 'IP': 'IP...', 'Select phone number confirmed status': '--電話番号確認ステータスを選択--', 'Others': 'その他', 'Confirmed': '確認済み', 'Pending': '保留中', 'Direct Link': '直接リンク', 'File': 'ファイル', 'Accepted': '受領済み', 'Choose': '--選択してください--', 'Signup Ip': '登録時IP', 'Phone Number Confirmed': '電話番号確認済み', 'User Email': 'ユーザーメールアドレス', 'Referral Email': '紹介メールアドレス', 'Creation Date': '作成日', 'Filter': 'フィルター', 'Invited': '招待済み', 'Manual': '手動', 'Refer': '紹介', 'Enter Here': 'ここに入力', 'Mobile': '電話番号', 'Email*': 'メールアドレス*', 'Name*': '氏名*', 'Refer a friend': '友達を紹介', 'Import': 'インポート', 'No File Chosen': 'ファイルが選択されていません', 'Choose File': 'ファイルを選択', 'CSV Info': '氏名、メールアドレス、電話番号の順で記載された友達の情報を含むCSVファイルから複数の友達を紹介できます。サンプルファイルをダウンロードするにはこちらをクリックしてください。', 'Upload From a CSV list': 'CSVリストからアップロード', 'Referral Info': 'DX Panel に友達を紹介し、Facebook、Twitter、その他のソーシャルメディアでリンクを共有することでポイントを獲得できます。あなたの紹介リンクURLは: /#/referrals/view/d8010ed8-fc05-4ea8-a505-7cf7692d21c8 です。', 'Refer with link': 'リンクで紹介', 'Referral': '紹介', 'Updated At': '更新日時', 'Created At': '作成日時', 'Referral Method': '紹介方法', 'Referral Status': '紹介ステータス', 'Phone Number': '電話番号', 'Email': 'メールアドレス', 'Name': '氏名', 'S.No': '番号', 'Referrals': '紹介' }

export const referralDict = {
  en: referralDictEN,
  hi: referralDictHI,
  jp: referralDictJP
};

export const referralModalDict = {
  en: {
    "Referral": "Referral",
    "Refer with link": "Refer with link",
    "Upload From a CSV list": "Upload From a CSV list",
    "Refer a friend": "Refer a friend",
    "Name": "Name",
    "Email": "Email",
    "Mobile": "Mobile",
    "Enter here": "Enter here",
    "Enter..": "Enter..",
    "Import": "Import",
    "Refer": "Refer",
    // "Referral Link Description": "You can earn points by referring your friends to DX Panel by sharing the given link on Facebook, Twitter, and other social media. Your unique referral link URL is:",
    // "CSV Description": "You can refer multiple friends from a CSV file that contains your friends' information in order name, email, mobile. Click here to refer a friend to download a sample file.",
    "Referral Link Description": "You can earn upto {maxPoints} {pointsLabel} every month (refer 10 friends each month) at {brand} by sharing the given link on Facebook, Twitter, and other social media. Your unique referral link URL is:",
    "CSV Description": "You can refer friends in bulk (maximum 10 in a month) using a CSV file that contains their information, including name, email, and mobile number. Click here to download a sample file.",
    "No File Chosen": "No file chosen",
    "Download": "Download",
    "Refer via whatsapp": "Refer via ",
    "Refer via email": "Refer via email",
    "Remaining Referrals" : "Remaining Referrals:",
    "No more referrals" : "You have exceeded the limit of referrals within 30 days.",
    "Already email sent": "You have already send invite to this email",
  },
  hi: {
    "Referral": "रेफरल",
    "Refer with link": "लिंक के साथ देखें",
    "Upload From a CSV list": "CSV सूची से अपलोड करें",
    "Refer a friend": "एक मित्र को रेफर करें",
    "Name": "नाम",
    "Email": "ईमेल",
    "Mobile": "मोबाइल",
    "Enter here": "दर्ज करें..",
    "Enter..": "दर्ज करें..",
    "Import": "अपलोड करें",
    "Refer": "रेफर देना",
    // "Referral Link Description": "आप Facebook, Twitter, और अन्य सोशल मीडिया पर दिए गए लिंक को साझा करके अपने दोस्तों को DX Panel में रेफर करके पॉइंट अर्जित कर सकते हैं। आपका अद्वितीय रेफरल लिंक URL है:",
    // "CSV Description": "आप एक .csv फ़ाइल से कई मित्रों को रेफर कर सकते हैं जिसमें क्रम नाम, ईमेल, मोबाइल में आपके मित्र की जानकारी होती है। किसी मित्र को रेफर करने के लिए फ़ाइल डाउनलोड करने के लिए यहाँ क्लिक करें.",
    "Referral Link Description": "आप {brand} पर हर महीने दिए गए लिंक को फेसबुक, ट्विटर और अन्य सोशल मीडिया पर साझा करके {maxPoints} {pointsLabel} तक कमा सकते हैं (हर महीने 10 दोस्तों को रेफर करें) : ",
    "CSV Description": "आप एक CSV फ़ाइल का उपयोग करके एक साथ दोस्तों का रेफरल दे सकते हैं (एक महीने में अधिकतम 10), जिसमें उनके नाम, ईमेल और मोबाइल नंबर जैसी जानकारी शामिल है। एक सैंपल फ़ाइल डाउनलोड करने के लिए यहाँ क्लिक करें।",
    "No File Chosen": "कोई फाइल नहीं चुनी गई",
    "Download": "डाउनलोड",
    "Refer via whatsapp": " से रेफर करें",
    "Refer via email": "ईमेल से रेफर करें",
    "Remaining Referrals" : "बचे हुए रेफरल:",
    "No more referrals" : "आपने 30 दिनों के भीतर रेफरल की सीमा पार कर ली है।",
    "Already email sent": "आपने पहले ही इस ईमेल पर निमंत्रण भेज दिया है।",
  },
  jp: {
    "Referral": "紹介",
    "Refer with link": "リンクで紹介",
    "Upload From a CSV list": "CSVリストからアップロード",
    "Refer a friend": "友達を紹介",
    "Name": "氏名",
    "Email": "メールアドレス",
    "Mobile": "電話番号",
    "Enter here": "ここに入力",
    "Enter..": "入力..",
    "Import": "インポート",
    "Refer": "紹介",
    "Referral Link Description": "{brand} で毎月最大 {maxPoints} {pointsLabel} を獲得できます（毎月10人の友達を紹介）。Facebook、Twitter、その他のソーシャルメディアでリンクを共有してください。あなたの紹介リンクURLは:",
    "CSV Description": "氏名、メールアドレス、電話番号を含むCSVファイルを使用して、まとめて友達を紹介できます（1ヶ月最大10名）。サンプルファイルをダウンロードするにはこちらをクリックしてください。",
    "No File Chosen": "ファイルが選択されていません",
    "Download": "ダウンロード",
    "Refer via whatsapp": "経由で紹介 ",
    "Refer via email": "メールで紹介",
    "Remaining Referrals" : "残りの紹介数:",
    "No more referrals" : "30日以内の紹介の上限を超えています。",
    "Already email sent": "このメールアドレスには既に招待を送信しています",
  }
};
